import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faUsers, faChartLine, faChartBar } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Qualitative Research",
    "User Interviews",
    "Usability Testing",
    "Surveys",
    "Behavioral Analysis",
    "Empathy Mapping",
    "Journey Mapping",
    "Heuristic Evaluation",
    "SPSS",
    "Excel"
];

const labelsSecond = [
    "Figma",
    "Miro",
    "Notion",
    "Google Forms",
    "Survey Monkey",
    "Canva",
    "User Personas",
    "Wireframing",
    "A/B Testing"
];

const labelsThird = [
    "Psychology",
    "Counselling",
    "CBT",
    "NLP",
    "Art Therapy",
    "Emotional Design",
    "Well-being Research",
    "Motivation Studies",
    "Group Therapy"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
        <h1 className="expertise-title">
                <FontAwesomeIcon icon={faChartBar} className="title-icon" />
                Expertise
            </h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faBrain} size="3x"/>
                    <h3>Psychology & Human Behavior</h3>
                    <p>With 6.5 years of experience in psychology and counselling, I bring a deep understanding of human motivation, emotion, and behavior to create empathy-driven, emotionally intelligent user experiences.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Specializations:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faUsers} size="3x"/>
                    <h3>UX Research & User Insights</h3>
                    <p>I combine psychological principles with UX research methods to uncover deep user insights. Through qualitative interviews, usability studies, and behavioral analysis, I translate user needs into actionable design recommendations.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Research Methods:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faChartLine} size="3x"/>
                    <h3>Design Tools & Analysis</h3>
                    <p>I leverage modern design and research tools to visualize insights, collaborate with teams, and create compelling research deliverables that inspire design decisions and drive product improvements.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tools & Software:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;